<template>
    <div>
        <Banner />

        <div class="w">

            <div class="row_1">
                <div>
                    <div class="head">
                        <div class="left">
                            <div class="head_icon">
                                <span :class="icon"></span>
                            </div>
                            <div class="title">
                                馆藏检索
                            </div>
                        </div>
                    </div>
                    <LibrarySearch />
                </div>
                <div>
                    <div class="ksdh">
                        <div class="head">
                            <div class="left">
                                <div class="head_icon">
                                    <span class="el-icon-notebook-2"></span>
                                </div>
                                <div class="title">
                                    快速导航
                                </div>
                                <!-- <div class="en_title">{{enTitle}}</div> -->
                            </div>
                            <div class="right">
                                <span>
                                    <a href="#"></a>
                                </span>
                            </div>
                        </div>
                        <div class="box">
                            <div v-for="item in ksdhList">
                                <img :src="item.imgUrl" class="box_img" @click="jumpMenu(item)">
                                <div class="hide"></div>
                                <div class="dh_title">{{ item.title }}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row_2">
                <div>
                    <ArticleListWindow :isHomePage="isHomePage" :articleModel="180104" icon="el-icon-video-camera-solid"
                        title="新闻动态" style="height: 420px;" />
                </div>
                <div>
                    <ArticleListWindow :isHomePage="isHomePage" :articleModel="180103" icon="el-icon-user" title="通知公告"
                        style="height: 420px;" />
                </div>
                <div>
                    <ArticleListWindowTwo :isHomePage="isHomePage" :articleModel="180105" icon="el-icon-video-camera-solid"
                        title="读者园地" style="height: 420px;" />
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import Banner from "@/components/Banner"
import ArticleListWindow from "@/components/ArticleListWindow"
import ArticleListWindowTwo from "@/components/ArticleListWindowTwo"
import CarouselArticleListWindow from "@/components/CarouselArticleListWindow"
import LibrarySearch from "@/components/LibrarySearch"

export default {
    name: 'DepartmentContent',
    components: { Banner, LibrarySearch, ArticleListWindow, CarouselArticleListWindow, ArticleListWindowTwo },
    data() {
        return {
            ksdhList: [


                {
                    imgUrl: require('@/assets/imgs/本馆概况.png'),
                    title: '本馆概况',
                    url: '/ArticleInit/list?articleModel=111801'
                },
                {
                    imgUrl: require('@/assets/imgs/数字资源.png'),
                    title: '数字资源',
                    url: '/ArticleInit/list?articleModel=111803'
                },
                {
                    imgUrl: require('@/assets/imgs/规章制度.png'),
                    title: '规章制度',
                    url: '/ArticleInit/list?articleModel=111802'
                },
                {
                    imgUrl: require('@/assets/imgs/每日荐读.png'),
                    title: '每日荐读',
                    url: '/ArticleInit/list?articleModel=111804'
                },
                {
                    imgUrl: require('@/assets/imgs/期刊导航.png'),
                    title: '期刊导航',
                    url: '/ArticleInit/list?articleModel=111805'
                },
                {
                    imgUrl: require('@/assets/imgs/公众号.png'),
                    title: '公众号',
                    url: ''
                },
            ],
            isHomePage: '0'
        }
    },
    methods: {
        jumpMenu(item) {
            this.$router.push(item.url)
        }
    }
}
</script>
<style scoped>
.w>div {
    margin-top: 30px;
}

.click_more {
    white-space: nowrap;
    font-size: 14px;
    display: inline-block;
    position: absolute;
    right: 10px;
    bottom: 5px;
    cursor: pointer;
}

img {
    height: 80px;
    width: 80px;
}

.row_1 {
    display: flex;
}

.row_1>div:first-child {
    flex-flow: column;
    display: flex;
    flex: 2;
    margin: 0 0.05rem;
}

.row_1>div:last-child {
    flex: 1;
}

.row_2 {
    display: flex;
}

.row_2>div {
    flex: 1;
    margin: 0 0.05rem;
}

.head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #6510ad;
    padding-bottom: 10px;
}

.en_title {
    margin-left: 10px;
}

.head>.left {
    display: flex;
}

.head>.left {
    font-size: 0.125rem;
    font-weight: 700;
    line-height: 00.125rem;
}

.head_icon {
    margin-right: 5px;
}

.head_icon>span {
    font-weight: 700;
    color: #23487e;
}

.head>.right {
    position: relative;
}

.head>.right>span {
    position: absolute;
    bottom: 0;
    right: 0;
}

.head>.right>span>a {
    text-decoration: none;
    font-size: 0.07rem;
    width: 0.28rem;
    display: inline-block;
    color: #2c3e50;
}

.ksdh {
    height: 420px;
    display: flex;
    flex-direction: column;
}

.box {
    padding-top: 30px;
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row: 100px 100px;
    grid-column-gap: 10px;
    grid-row-gap: 20px;
}

.box>div {
    text-align: center;
}

.box_img {
    cursor: pointer;
}


.box>div:last-child>img:hover .box>div:last-child>div:first-child {
    display: block;
}

/* .box>div:last-child>div:first-child {
    width: 204px; 鼠标移动到元素显示二维码 TODO
    height: 204px;
    background: url("../assets/imgs/数字资源.png");
    background-size: 100%;
    position: absolute;
    right: 330px;
    display: none;
} */

.hide {
    display: none;
}

.dh_title {
    text-align: center;
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/LibraryContent.vue